import { render } from "./View.pug?vue&type=template&id=7377d06c&ts=true&lang=pug&external"
import script from "./View.ts?vue&type=script&lang=ts&external"
export * from "./View.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/View.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7377d06c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7377d06c', __exports__)) {
    api.reload('7377d06c', __exports__)
  }
  
  module.hot.accept("./View.pug?vue&type=template&id=7377d06c&ts=true&lang=pug&external", () => {
    api.rerender('7377d06c', render)
  })

}


export default __exports__